/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum NotificationTitle {
  Temperature = 'TEMPERATURE',
  WaterConsumption = 'WATER_CONSUMPTION',
  GatewayDisconnect = 'GATEWAY_DISCONNECT',
  Recharge = 'RECHARGE'
}
